import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { clsx } from 'clsx'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, className, id, rows = 3, ...props }, ref) => {
    const textareaId = id ?? props.name
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={textareaId} className="text-xs font-semibold text-muted">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          rows={rows}
          className={clsx(
            'resize-y rounded-lg border border-line bg-panel-2 px-2.5 py-2.5 text-text outline-none',
            'focus:border-accent focus:ring-2 focus:ring-accent/20',
            error && 'border-danger',
            className,
          )}
          aria-invalid={Boolean(error)}
          aria-describedby={error && textareaId ? `${textareaId}-error` : undefined}
          {...props}
        />
        {error && (
          <span id={textareaId ? `${textareaId}-error` : undefined} className="text-xs text-[#ff8d9a]">
            {error}
          </span>
        )}
      </div>
    )
  },
)
Textarea.displayName = 'Textarea'
